import type { ReactNode } from 'react';

export const symbol_tv_guide: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Zm140 210v220q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-220h123l90 232q2.97 8.25 10.03 13.12Q610.09-320 619-320h21.7q9.3 0 16.32-4.88 7.02-4.87 9.98-13.12l96-248q6-16-3.82-30t-27.27-14q-10.91 0-18.41 5.5T702-609l-72 188-73-190q-3-9-11-14t-17-5H210q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h110Z"
		/>
	</svg>
);
